import React, { useEffect, useState } from "react";
import { EuiFieldText, EuiFlexGroup, EuiFlexItem, EuiSelect } from "@elastic/eui";

const DurationUnitsOption = [
  {
    value: "minute",
    text: "Minute(s)",
  },
  {
    value: "hour",
    text: "Hour(s)",
  },
  {
    value: "day",
    text: "Day(s)",
  },
];

const FdDurationControl = ({
  onChange,
  Name,
  ControlProps,
  isInvalid,
  readOnly,
  disabled,
  inputRef,
  value,
}) => {
  const [num, setNum] = useState(value?.val ?? 30);
  const [unit, setUnit] = useState(value?.unit ?? "minute");

  useEffect(() => {
    if (value != null) {
      setNum(value.val);
      setUnit(value.unit);
    }
  }, [value]);

  return (
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFieldText
          min="1"
          name={Name}
          onChange={(e) => {
            setNum(+e.target.value);
            return onChange({ val: e.target.value, unit });
          }}
          type="number"
          {...(ControlProps || {})}
          disabled={disabled}
          inputRef={inputRef}
          isInvalid={isInvalid}
          readOnly={readOnly || false}
          value={num}
          style={{ width: "80px" }}
        />
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiSelect
          style={{ width: "110px" }}
          onChange={(e) => {
            setUnit(e.target.value);
            return onChange({ val: num, unit: e.target.value });
          }}
          options={DurationUnitsOption}
          value={unit}
        />
      </EuiFlexItem>
    </EuiFlexGroup>
  );
};

export default FdDurationControl;
